module.exports = __webpack_public_path__ + "static/media/photo25.bfaa3672.jpg";